/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateDefaultInstrumentBackfillRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateDefaultInstrumentBackfill.pb'
import {UpdateDefaultInstrumentBackfillResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateDefaultInstrumentBackfill.pb'


export const updateDefaultInstrumentBackfill = (request: UpdateDefaultInstrumentBackfillRequest, options?: CashRequestOptions) => post<UpdateDefaultInstrumentBackfillRequest, UpdateDefaultInstrumentBackfillResponse>("/2.0/cash/update-default-instrument-backfill", request, {...options, rejectOnError: true })